import { useEffect, useState } from "react";
import "./index.scss";
import Select from "react-select";
import { toast } from "react-toastify";
import { getProducts } from "../../services/get-all-products";
import { getPackageProductsAndProducts } from "../../services/getPackageProductsAndProducts";

const selectStyles = {
  control: (base: any) => ({
    ...base,
    minHeight: 56,
    borderRadius: 12,
    borderColor: "#ddd",
    boxShadow: "none",
    "&:hover": { borderColor: "#1ea182" },
  }),
  multiValue: (base: any) => ({
    ...base,
    backgroundColor: "#e8f7f2",
    borderRadius: 8,
  }),
  multiValueLabel: (base: any) => ({
    ...base,
    color: "#1ea182",
    fontWeight: 600,
  }),
  multiValueRemove: (base: any) => ({
    ...base,
    color: "#1ea182",
    ":hover": { backgroundColor: "#cfeee6", color: "#0e572a" },
  }),
};

const ModalAssociatedProds = ({
  setStep,
  selectedOption,
  setSelectedOption,
  SubmitPackage,
  editMode,
  productsValues,
  closeModal,
  loadingSave
}: any) => {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (options: any) => {
    setSelectedOption(options);
  };

  const groupedOptions = products.reduce((acc: any[], product) => {
    const category = product?.subCategory?.name || "Other";

    const existing = acc.find((c) => c.label === category);
    const option = { value: product._id, label: product.name };

    if (existing) {
      existing.options.push(option);
    } else {
      acc.push({ label: category, options: [option] });
    }

    return acc;
  }, []);

  const loadAssociatedProducts = async (packageId: string) => {
    try {
      const res = await getPackageProductsAndProducts(packageId);
      if (!res?.success) return toast.error(res?.message);

      setSelectedOption(
        res.content.products.map((p: any) => ({
          value: p._id,
          label: p.name,
        }))
      );
    } catch {
      toast.error("Failed to load associated products");
    }
  };

  const loadProducts = async () => {
    try {
      setLoading(true);
      const res = await getProducts();
      if (!res?.success) return toast.error(res?.message);
      setProducts(res.content);
    } catch {
      toast.error("Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProducts();
    if (editMode && productsValues?._id) {
      loadAssociatedProducts(productsValues._id);
    }
  }, []);

  return (
    <div className="association-modal">
      {/* HEADER */}
      <header className="association-header">
        <h2>Associated Products</h2>
        <button className="close-btn" onClick={closeModal}>
          <i className="bx bx-x" />
        </button>
      </header>

      {/* BODY */}
      <main className="association-body">
        <p className="helper-text">
          Select products that belong to this package
        </p>

        <Select
          value={selectedOption}
          onChange={handleChange}
          options={groupedOptions}
          isMulti
          isLoading={loading}
          closeMenuOnSelect={false}
          styles={selectStyles}
          placeholder="Choose products..."
        />
      </main>

      {/* FOOTER */}
      <footer className="association-footer">
        <div className="stepper">
          <span />
          <span />
          <span className="active" />
        </div>

        <div className="actions">
          <button className="btn-outline" onClick={() => setStep("second")}>
            Back
          </button>
          <button className="btn-primary" onClick={SubmitPackage} disabled={loadingSave}>
           { loadingSave ? "En cours ..." :"Enregister"}
          </button>
        </div>
      </footer>
    </div>
  );
};

export default ModalAssociatedProds;
